import classNames from "classnames";
import React from "react";
import KuikaSvg from "../../../ui-kit/kuika-svg/kuika-svg";
import { IPropertyRowIconInfo, PROPERTY_ROW_ICONS, PropertyRowKind } from "./property-row-icons";
import "./property-row-icon.scss";

export interface IPropertyRowIconProps {
  kind: PropertyRowKind;
}

/**
 * The 24px solid tile that leads a row in a grouped property card (Role, Is Offline,
 * Authorization, …). Decorative: the row's own label names it, so the tile is hidden from
 * assistive tech. Glyph and tone come from `PROPERTY_ROW_ICONS`; the colour itself lives in
 * `property-row-icon.scss`.
 */
const PropertyRowIcon: React.FC<IPropertyRowIconProps> = ({ kind }: IPropertyRowIconProps): JSX.Element => {
  const info: IPropertyRowIconInfo = PROPERTY_ROW_ICONS[kind];

  return (
    <span
      className={classNames("kuika-property-row-icon", `kuika-property-row-icon--${info.tone}`)}
      data-testid="propertyRowIcon"
      data-row-kind={kind}
      aria-hidden="true"
    >
      <KuikaSvg name={info.iconName} width={14} height={14} color="var(--white)" />
    </span>
  );
};

export default PropertyRowIcon;
